export default __webpack_public_path__ + "static/21-7f5d980de41d7ce04c0752109dc6de52.jpg";